export const getFlowpageHost = (): string => {
  switch (process.env.APP_ENV) {
    case 'development':
    case 'staging':
      return `stg.flow.page`
    case 'production':
    default:
      return `flow.page`
  }
}

export const getFlowcodeHost = (): string => {
  switch (process.env.APP_ENV) {
    case 'development':
    case 'staging':
      return `stg.flowcode.com`
    case 'production':
    default:
      return `www.flowcode.com`
  }
}

export const getFlowcodeHostPrefix = (): string => {
  switch (process.env.APP_ENV) {
    case 'development':
    case 'staging':
      return 'stg.'
    case 'production':
    default:
      return ''
  }
}
